var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356.445,
    height: 301.369,
    viewBox: "0 0 356.445 301.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14458",
    "data-name": "Group 14458",
    transform: "translate(-36.087 -19.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14429",
    "data-name": "Group 14429"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6231",
    "data-name": "Rectangle 6231",
    width: 29.613,
    height: 0.217,
    transform: "translate(269.56 292.26)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6233",
    "data-name": "Rectangle 6233",
    width: 9.669,
    height: 0.217,
    transform: "translate(140.508 293.08)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6234",
    "data-name": "Rectangle 6234",
    width: 33.328,
    height: 0.217,
    transform: "translate(99.458 293.08)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14435",
    "data-name": "Group 14435",
    transform: "translate(36.087 19.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14430",
    "data-name": "Group 14430",
    transform: "translate(0 22.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113166",
    "data-name": "Path 113166",
    d: "M193.068,188.086l.391-11.409-7-2.289a67.985,67.985,0,0,0-1.867-11.456l5.937-4.377-4.033-10.716-7.343.592a67.127,67.127,0,0,0-6.113-9.854l3.8-6.349-7.821-8.344-6.564,3.362a71.6,71.6,0,0,0-9.411-6.8l1.064-7.287-10.416-4.727-4.772,5.594a70.448,70.448,0,0,0-11.3-2.648l-1.775-7.143L114.4,103.84l-2.258,7a70.529,70.529,0,0,0-11.456,1.868L96.28,106.8l-10.715,4,.592,7.345a69.826,69.826,0,0,0-9.854,6.141l-6.319-3.8L61.61,128.28l3.361,6.595a67.169,67.169,0,0,0-6.772,9.413l-7.286-1.093-4.757,10.414,5.622,4.774a68.109,68.109,0,0,0-2.648,11.3l-7.175,1.8L41.566,182.9l7.034,2.291a67.452,67.452,0,0,0,1.868,11.455l-5.936,4.377,4.033,10.718,7.343-.593A67.287,67.287,0,0,0,62.02,221l-3.8,6.349,7.821,8.345,6.564-3.362a69.979,69.979,0,0,0,9.411,6.8l-1.094,7.285,10.416,4.727,4.8-5.592a70.5,70.5,0,0,0,11.3,2.647l1.775,7.143,11.438.392,2.26-7a70.532,70.532,0,0,0,11.456-1.868l4.378,5.907,10.715-4-.562-7.342a71.6,71.6,0,0,0,9.854-6.143l6.319,3.8,8.374-7.79-3.36-6.595a67.233,67.233,0,0,0,6.772-9.412l7.286,1.094,4.757-10.415-5.623-4.774a67.279,67.279,0,0,0,2.647-11.3Zm-77.091,36.959a45.284,45.284,0,1,1,46.793-43.693A45.273,45.273,0,0,1,115.977,225.045Z",
    transform: "translate(-41.566 -103.84)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14431",
    "data-name": "Group 14431",
    transform: "translate(304.071 22.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113167",
    "data-name": "Path 113167",
    d: "M434.491,150.341l2.877-2.686-1.149-2.266a23.409,23.409,0,0,0,2.338-3.25l2.515.38,1.63-3.6-1.935-1.646a23.151,23.151,0,0,0,.912-3.894l2.476-.621.128-3.941-2.42-.781a24.73,24.73,0,0,0-.636-3.953l2.037-1.518-1.387-3.693-2.528.2a24.306,24.306,0,0,0-2.11-3.4l1.309-2.175-2.694-2.885-2.259,1.158a24.3,24.3,0,0,0-3.249-2.339l.366-2.515-3.589-1.637-1.647,1.935a24.066,24.066,0,0,0-3.9-.906l-.614-2.468-3.941-.142-.788,2.427a23.137,23.137,0,0,0-3.947.644l-1.51-2.044-3.7,1.38.207,2.534a23.578,23.578,0,0,0-3.4,2.111l-2.189-1.31-2.877,2.687,1.156,2.274a23.294,23.294,0,0,0-2.338,3.249l-2.514-.38-1.63,3.6,1.935,1.646a23.224,23.224,0,0,0-.912,3.893l-2.475.621-.128,3.942,2.421.78a24.008,24.008,0,0,0,.635,3.954l-2.043,1.51,1.387,3.692,2.534-.193a24.227,24.227,0,0,0,2.111,3.4l-1.309,2.175,2.694,2.885,2.259-1.157a24.26,24.26,0,0,0,3.249,2.338l-.372,2.508,3.589,1.637,1.653-1.927a24.624,24.624,0,0,0,3.9.9l.613,2.468,3.942.142.788-2.427a23.122,23.122,0,0,0,3.947-.643l1.51,2.043,3.7-1.38-.208-2.535a23.344,23.344,0,0,0,3.4-2.11Zm-20.5-16.609a5.618,5.618,0,1,1,7.939.272A5.618,5.618,0,0,1,413.988,133.732Z",
    transform: "translate(-391.908 -103.703)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113168",
    "data-name": "Path 113168",
    d: "M302.166,284.569l-8.978-6.2c0-.007,0-.015-.005-.022A49.293,49.293,0,0,0,289.572,269l2.3-9.026L278.85,246.022l-9.167,1.678a49.36,49.36,0,0,0-9.076-4.238.239.239,0,0,1-.023-.008l-5.574-9.384-19.069-.654-6.2,8.978-.036.009a49.36,49.36,0,0,0-9.342,3.606l-9.023-2.3L197.4,256.732l1.675,9.149,0,.008A48.364,48.364,0,0,0,194.825,275l-9.383,5.571-.654,19.069,8.986,6.206a47.758,47.758,0,0,0,3.6,9.392l0,0-2.294,9,13.023,13.945,9.11-1.667a49.786,49.786,0,0,0,9.156,4.248l.008,0,5.564,9.371,19.069.654,6.2-8.972a49.691,49.691,0,0,0,9.421-3.61l0,0,8.981,2.289,13.946-13.021-1.675-9.151a48.368,48.368,0,0,0,4.241-9.112v0l9.387-5.575Zm-59.428,28.988a21.457,21.457,0,1,1,22.178-20.709A21.463,21.463,0,0,1,242.738,313.557Z",
    transform: "translate(-60.492 -99.463)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113169",
    "data-name": "Path 113169",
    d: "M335.342,215.346h-.062l-15.034-.515a1.832,1.832,0,0,1-1.513-.9l-4.048-6.817a41.25,41.25,0,0,1-6.322-2.933l-6.517,1.192a1.821,1.821,0,0,1-1.67-.552L289.908,193.83a1.836,1.836,0,0,1-.437-1.7l1.639-6.433a39.884,39.884,0,0,1-2.482-6.485l-6.538-4.515a1.834,1.834,0,0,1-.791-1.571l.516-15.034a1.83,1.83,0,0,1,.9-1.513l6.829-4.055a40.186,40.186,0,0,1,2.926-6.293l-1.2-6.54a1.835,1.835,0,0,1,.552-1.669l11-10.268a1.833,1.833,0,0,1,1.7-.437l6.455,1.645a40.747,40.747,0,0,1,6.467-2.493l4.512-6.533a1.773,1.773,0,0,1,1.571-.79l15.034.515a1.831,1.831,0,0,1,1.513.9l4.056,6.829a40.81,40.81,0,0,1,6.274,2.927l6.558-1.2a1.834,1.834,0,0,1,1.67.552l10.266,11a1.836,1.836,0,0,1,.437,1.7l-1.645,6.457a40.711,40.711,0,0,1,2.493,6.464l6.533,4.512a1.834,1.834,0,0,1,.791,1.571l-.515,15.036a1.833,1.833,0,0,1-.9,1.513l-6.832,4.057a40.133,40.133,0,0,1-2.922,6.288l1.2,6.543a1.831,1.831,0,0,1-.552,1.669l-10.995,10.265a1.828,1.828,0,0,1-1.7.437l-6.425-1.637a41.075,41.075,0,0,1-6.5,2.492l-4.507,6.528A1.835,1.835,0,0,1,335.342,215.346ZM321.373,211.2l13.03.446,4.316-6.249a1.833,1.833,0,0,1,1.032-.728,37.419,37.419,0,0,0,7.079-2.714l.012-.006a1.826,1.826,0,0,1,1.266-.133l6.111,1.557,9.529-8.9-1.14-6.228a1.836,1.836,0,0,1,.233-1.276,36.408,36.408,0,0,0,3.169-6.8,1.84,1.84,0,0,1,.818-1.017l6.53-3.879.447-13.031-6.254-4.319a1.827,1.827,0,0,1-.7-.928c-.016-.046-.03-.1-.043-.147a36.962,36.962,0,0,0-2.7-6.992,1.836,1.836,0,0,1-.142-1.283l1.566-6.145-8.9-9.532-6.241,1.143a1.829,1.829,0,0,1-1.269-.229,37.163,37.163,0,0,0-6.812-3.183,2.03,2.03,0,0,1-.383-.178,1.83,1.83,0,0,1-.616-.626l-3.882-6.536-13.031-.447-4.318,6.254a1.833,1.833,0,0,1-1.079.741,37.157,37.157,0,0,0-6.992,2.7,1.83,1.83,0,0,1-1.282.142l-6.142-1.565-9.53,8.9,1.14,6.227a1.833,1.833,0,0,1-.164,1.149c-.025.049-.052.1-.082.148a36.4,36.4,0,0,0-3.172,6.823,1.837,1.837,0,0,1-.8.974l-6.536,3.882L285,172.245l6.26,4.323a1.827,1.827,0,0,1,.728,1.031,36.183,36.183,0,0,0,2.7,7.047,1.8,1.8,0,0,1,.148.394,1.823,1.823,0,0,1,0,.9l-1.561,6.124,8.9,9.528,6.2-1.133a1.839,1.839,0,0,1,1.263.226,37.631,37.631,0,0,0,6.847,3.182,1.829,1.829,0,0,1,1.02.81Zm21.516-82.313h0Zm-13.468,65.848c-.321,0-.642-.006-.965-.017a27.384,27.384,0,1,1,.965.017Zm-.033-51.3a23.84,23.84,0,1,0,.826.015C329.937,143.436,329.661,143.431,329.388,143.431Z",
    transform: "translate(-73.256 -82.909)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14432",
    "data-name": "Group 14432",
    transform: "translate(288.818 9.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113170",
    "data-name": "Path 113170",
    d: "M382.239,103.754l-6.228-1.673-1.672-6.228,2.438-2.438,2.573,5.328,5.328,2.573Z",
    transform: "translate(-374.339 -89.342)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113171",
    "data-name": "Path 113171",
    d: "M383.261,99.191a2.906,2.906,0,1,0-4.111-4.109l3.1-4.648,4.155,2.1.911,4.365Z",
    transform: "translate(-374.973 -88.949)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113172",
    "data-name": "Path 113172",
    d: "M376.582,93.288l4.564-4.564,6.227,1.672,1.672,6.228-4.563,4.564-6.228-1.673Zm8.287,3.731a2.906,2.906,0,1,0-4.11-.009A2.917,2.917,0,0,0,384.869,97.019Z",
    transform: "translate(-374.635 -88.724)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14433",
    "data-name": "Group 14433",
    transform: "translate(38.747 181.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113173",
    "data-name": "Path 113173",
    d: "M90.022,295.866l3.342-.9.9-3.342-1.308-1.308-1.381,2.859-2.859,1.381Z",
    transform: "translate(-86.529 -288.133)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113174",
    "data-name": "Path 113174",
    d: "M89.652,293.417a1.559,1.559,0,1,1,2.205-2.205L90.2,288.718l-2.229,1.127-.489,2.343Z",
    transform: "translate(-86.366 -287.922)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113175",
    "data-name": "Path 113175",
    d: "M92.885,290.25,90.436,287.8l-3.342.9-.9,3.342,2.448,2.449,3.342-.9Zm-4.448,2a1.56,1.56,0,1,1,2.206,0A1.565,1.565,0,0,1,88.438,292.252Z",
    transform: "translate(-86.197 -287.801)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14434",
    "data-name": "Group 14434",
    transform: "translate(25.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113176",
    "data-name": "Path 113176",
    d: "M76.281,85.181l2.773,2.774a1.862,1.862,0,0,0,2.626,0h0a1.862,1.862,0,0,0,0-2.626l-2.774-2.773a1.861,1.861,0,0,0-2.625,0h0A1.861,1.861,0,0,0,76.281,85.181Z",
    transform: "translate(-71.303 -78.015)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113177",
    "data-name": "Path 113177",
    d: "M73.69,77.666a3.868,3.868,0,1,1-2.565,5.023A3.993,3.993,0,0,1,73.69,77.666Z",
    transform: "translate(-70.666 -77.408)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6236",
    "data-name": "Rectangle 6236",
    width: 1.189,
    height: 8.77,
    transform: "matrix(-0.338, -0.941, 0.941, -0.338, 0.402, 5.933)",
    fill: "#f0f0f0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    transform: "translate(61.78 38.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14445",
    "data-name": "Group 14445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14438",
    "data-name": "Group 14438",
    transform: "translate(0 41.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113185",
    "data-name": "Path 113185",
    d: "M124.856,168.3a.438.438,0,0,1-.157-.03c-3.908-1.513-6.245-2.992-7.459-4.768a4.492,4.492,0,0,1-2.806-.386,5.587,5.587,0,0,1-2.414-2.276,2.22,2.22,0,0,1-2.106.326,5.357,5.357,0,0,1-2.563-2.093,1.983,1.983,0,0,1-1.347.373c-2.581-.21-6.079-5.348-6.33-10.824a.434.434,0,0,1,.867-.039c.238,5.2,3.568,9.837,5.533,10a1.1,1.1,0,0,0,.808-.243,10.65,10.65,0,0,1-.887-8.171c.747-2.608,1.406-3.628,2.2-3.44,1.495.372,1.3,6.053.507,9.8a5.318,5.318,0,0,1-.734,1.894,4.7,4.7,0,0,0,2.208,1.916,1.372,1.372,0,0,0,1.453-.3,10.086,10.086,0,0,1,.1-6.892c1.219-3.845,1.709-3.949,2-4.011a.574.574,0,0,1,.56.191c.8.906-.156,6.877-1.167,9.831a4.355,4.355,0,0,1-.484,1,4.755,4.755,0,0,0,2.164,2.171,3.794,3.794,0,0,0,1.973.374c-.078-.165-.148-.331-.212-.5-.688-1.864-.352-4.016,1.029-6.579.916-1.7,1.663-2.493,2.35-2.493h0a.963.963,0,0,1,.857.575c.757,1.4.208,6.007-1.288,8.295a3.4,3.4,0,0,1-1.4,1.215c1.163,1.529,3.372,2.877,6.9,4.245a.434.434,0,0,1-.157.839ZM119.948,154s-.491,0-1.586,2.038c-1.256,2.331-1.576,4.25-.979,5.866a4.738,4.738,0,0,0,.261.582,2.567,2.567,0,0,0,1.147-.959c1.215-1.858,1.8-5.676,1.346-7.169C120.043,154.056,119.948,154,119.948,154Zm-6.227-3.658a19.614,19.614,0,0,0-1.163,3.065,9.831,9.831,0,0,0-.334,5.685c.029-.073.056-.146.081-.218A28.742,28.742,0,0,0,113.721,150.345ZM108,147.611c-.147.135-.569.682-1.174,2.8a9.767,9.767,0,0,0,.631,7.159,5.56,5.56,0,0,0,.391-1.217C108.752,152.085,108.489,148.228,108,147.611Z",
    transform: "translate(-74.92 -146.706)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113186",
    "data-name": "Path 113186",
    d: "M166.064,222.31a7.82,7.82,0,0,1-3.96-1.031.435.435,0,1,1,.439-.75c3.1,1.819,7.1.55,7.924-.774a.755.755,0,0,0,.128-.583,7.067,7.067,0,0,1-4.455-1.273c-2.209-1.381-2.38-1.791-2.366-2.12a.534.534,0,0,1,.3-.455c.865-.438,4.779,1.367,6.411,2.44a2.823,2.823,0,0,1,.54.453,3.07,3.07,0,0,0,1.651-.994,2.486,2.486,0,0,0,.51-.974l-.174.021a5.5,5.5,0,0,1-4.264-1.827c-1.019-.942-1.415-1.591-1.283-2.106a.786.786,0,0,1,.623-.568c1.2-.3,4.165.965,5.377,2.294a2.429,2.429,0,0,1,.557,1.028,11.008,11.008,0,0,0,3.75-3.709.434.434,0,0,1,.707.505c-1.641,2.292-3.008,3.591-4.382,4.12a3.228,3.228,0,0,1-.754,1.771A3.937,3.937,0,0,1,171.448,219a1.6,1.6,0,0,1-.243,1.208C170.473,221.391,168.373,222.31,166.064,222.31Zm-.771-6.022c.292.216.71.5,1.307.874a7.014,7.014,0,0,0,3.126,1.149A21.554,21.554,0,0,0,165.293,216.288Zm3.03-3.688a3.751,3.751,0,0,0,1.012,1.2,4.681,4.681,0,0,0,3.586,1.6,2.788,2.788,0,0,0,.278-.042,1.59,1.59,0,0,0-.377-.716A7.479,7.479,0,0,0,168.323,212.6Z",
    transform: "translate(-83.121 -155.208)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113187",
    "data-name": "Path 113187",
    d: "M165.6,212.82l-13.528,2.457-12.282-67.033-26.1,4.741-42.531,75.53,4.567,24.924,54.553-9.909,3.735,20.386,26.1-4.742-3.735-20.385,13.528-2.458ZM97.148,225.254l22.537-39.561,6.288,34.325Z",
    transform: "translate(-71.161 -146.908)",
    fill: "#fec900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14441",
    "data-name": "Group 14441",
    transform: "translate(109.223 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113188",
    "data-name": "Path 113188",
    d: "M291.139,137.239a51.037,51.037,0,0,0-2.776-12.345,39.974,39.974,0,0,0-6.069-10.582,35.074,35.074,0,0,0-11.029-9q-6.98-3.813-18.424-5.306-23.821-3.1-37.142,8.456t-17.535,44.286a120.856,120.856,0,0,0-.847,24.608q.863,11.3,4.147,18.173a38,38,0,0,0,12.718,15.429q8.221,5.766,22.529,7.632,25.52,3.325,37.825-9.8t16.326-44.364A112.263,112.263,0,0,0,291.139,137.239Z",
    transform: "translate(-197.026 -99.349)",
    fill: "#fec900",
    stroke: "#fec900",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113189",
    "data-name": "Path 113189",
    d: "M246,211.13c-2.088-.071-4.311-.26-6.605-.559-7.947-1.035-14.1-3.046-18.278-5.98a28.331,28.331,0,0,1-9.543-11.638l-.043-.09c-1.669-3.493-2.76-8.467-3.243-14.783a111.987,111.987,0,0,1,.8-22.661c3.1-24.067,9.5-34.108,14.322-38.293,5.624-4.879,13.214-7.084,23.206-6.742,2.047.07,4.215.254,6.443.543,6.413.834,11.487,2.254,15.081,4.217a25.829,25.829,0,0,1,8.082,6.5,30.654,30.654,0,0,1,4.648,8.046,41.836,41.836,0,0,1,2.228,10.034,103.4,103.4,0,0,1-.254,24.936c-2.407,18.7-7.058,31.838-13.821,39.051-5.017,5.352-12.547,7.779-23.019,7.42Z",
    transform: "translate(-198.476 -100.799)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14439",
    "data-name": "Group 14439",
    transform: "translate(20.845 13.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113190",
    "data-name": "Path 113190",
    d: "M264.705,139.6l.113-3.289-2.019-.66a19.619,19.619,0,0,0-.539-3.3l1.712-1.262L262.81,128l-2.117.17a19.457,19.457,0,0,0-1.762-2.841l1.1-1.83-2.255-2.4-1.892.969a20.68,20.68,0,0,0-2.713-1.96l.306-2.1-3-1.362-1.375,1.612a20.267,20.267,0,0,0-3.257-.763l-.512-2.059-3.3-.113-.651,2.019a20.286,20.286,0,0,0-3.3.538l-1.271-1.7-3.088,1.154.17,2.117a20.245,20.245,0,0,0-2.84,1.77l-1.821-1.1-2.414,2.245.969,1.9a19.33,19.33,0,0,0-1.952,2.713l-2.1-.315-1.371,3,1.62,1.376a19.65,19.65,0,0,0-.763,3.257l-2.068.52-.112,3.289,2.027.66a19.392,19.392,0,0,0,.538,3.3l-1.711,1.262,1.162,3.089,2.117-.171a19.362,19.362,0,0,0,1.762,2.841l-1.1,1.83,2.254,2.4,1.893-.969a20.161,20.161,0,0,0,2.712,1.96l-.315,2.1,3,1.363,1.385-1.612a20.244,20.244,0,0,0,3.257.763l.511,2.059,3.3.113.651-2.019a20.292,20.292,0,0,0,3.3-.538l1.262,1.7,3.089-1.154-.162-2.117a20.634,20.634,0,0,0,2.841-1.77l1.821,1.1,2.414-2.246-.968-1.9a19.4,19.4,0,0,0,1.952-2.713l2.1.315,1.371-3-1.621-1.376a19.346,19.346,0,0,0,.763-3.257Zm-22.221,10.653a13.053,13.053,0,1,1,13.488-12.595A13.05,13.05,0,0,1,242.484,150.253Z",
    transform: "translate(-221.036 -115.316)",
    fill: "#fec900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14440",
    "data-name": "Group 14440",
    transform: "translate(48.837 81.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113191",
    "data-name": "Path 113191",
    d: "M282.661,210.2l.238-2.216-1.333-.543a13.636,13.636,0,0,0-.2-2.252l1.215-.772-.618-2.144-1.443.012a12.862,12.862,0,0,0-1.038-2.006l.823-1.182-1.393-1.734-1.33.554a13.163,13.163,0,0,0-1.729-1.452l.323-1.412-1.954-1.072-1.021,1.031a12.907,12.907,0,0,0-2.15-.683l-.247-1.42-2.216-.248-.543,1.332a13.936,13.936,0,0,0-2.252.207l-.771-1.225-2.145.628.012,1.443a13.918,13.918,0,0,0-2.007,1.039l-1.18-.833-1.735,1.393.554,1.33a14.069,14.069,0,0,0-1.451,1.728l-1.4-.313-1.072,1.955,1.022,1.01a13.93,13.93,0,0,0-.684,2.162l-1.42.235-.238,2.217,1.332.553a12.743,12.743,0,0,0,.2,2.243l-1.225.771.628,2.145,1.443,0a13.33,13.33,0,0,0,1.039,2l-.833,1.18,1.393,1.744,1.34-.563a13.284,13.284,0,0,0,1.728,1.452L260,219.9l1.954,1.073,1.02-1.022a13.764,13.764,0,0,0,2.151.673l.246,1.421,2.216.248.544-1.333a13.944,13.944,0,0,0,2.252-.207l.771,1.225,2.135-.629,0-1.442a14,14,0,0,0,2.007-1.038l1.17.832,1.744-1.393-.564-1.33a14.215,14.215,0,0,0,1.461-1.728l1.4.312,1.072-1.954-1.022-1.011a14.088,14.088,0,0,0,.674-2.151Zm-11.177-.86a3.874,3.874,0,1,1-1.538-5.254A3.882,3.882,0,0,1,271.484,209.341Z",
    transform: "translate(-253.278 -192.662)",
    fill: "#fec900",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113192",
    "data-name": "Path 113192",
    d: "M296.153,167.41l-2.588-1.787,0-.006a14.23,14.23,0,0,0-1.041-2.7l.663-2.6-3.754-4.021-2.642.484a14.24,14.24,0,0,0-2.616-1.222l-.007,0-1.606-2.705-5.5-.188-1.787,2.588-.01,0a14.2,14.2,0,0,0-2.692,1.04l-2.6-.663-4.02,3.754.483,2.637,0,0a13.929,13.929,0,0,0-1.222,2.626l-2.7,1.606-.188,5.5,2.59,1.788a13.79,13.79,0,0,0,1.038,2.708h0l-.661,2.594,3.753,4.02,2.626-.481a14.3,14.3,0,0,0,2.639,1.225h0l1.6,2.7,5.5.188,1.786-2.586a14.357,14.357,0,0,0,2.716-1.041h0l2.589.66,4.02-3.754-.483-2.638a13.93,13.93,0,0,0,1.222-2.626h0l2.706-1.607Zm-17.13,8.356a6.185,6.185,0,1,1,6.392-5.97A6.187,6.187,0,0,1,279.023,175.766Z",
    transform: "translate(-205.633 -106.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113193",
    "data-name": "Path 113193",
    d: "M321.746,117.234l.453-1.09h0a5.386,5.386,0,0,0,.908-.595l1.007.038,1.181-1.695-.385-.932a5.309,5.309,0,0,0,.242-1.057v0l.867-.8-.364-2.033-1.091-.452,0,0a5.278,5.278,0,0,0-.594-.906l.039-1.008-1.7-1.18-.93.385h0a5.239,5.239,0,0,0-1.061-.242l-.8-.866-2.033.364-.453,1.092a5.178,5.178,0,0,0-.912.594h0l-1-.038-1.181,1.695.384.926a5.4,5.4,0,0,0-.242,1.066h0l-.866.8.364,2.033,1.09.452a5.4,5.4,0,0,0,.6.915h0l-.038,1,1.695,1.181.931-.385a5.232,5.232,0,0,0,1.06.242h0l.8.866Zm-4.417-5.632a2.323,2.323,0,1,1,2.7,1.878A2.323,2.323,0,0,1,317.329,111.6Z",
    transform: "translate(-212.342 -100.066)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113194",
    "data-name": "Path 113194",
    d: "M295.506,111.741l-.662-.559a17.292,17.292,0,0,1,5.216-4.367l.4.77A16.613,16.613,0,0,0,295.506,111.741Z",
    transform: "translate(-209.921 -100.333)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113195",
    "data-name": "Path 113195",
    d: "M303.539,106.419l-.343-.8a20.757,20.757,0,0,1,10.191-1.632l-.081.865A19.767,19.767,0,0,0,303.539,106.419Z",
    transform: "translate(-211.022 -99.949)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113196",
    "data-name": "Path 113196",
    d: "M301.594,112.8l-.717-.489a14.578,14.578,0,0,1,8.57-5.546l.168.851A13.647,13.647,0,0,0,301.594,112.8Z",
    transform: "translate(-210.716 -100.327)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113197",
    "data-name": "Path 113197",
    d: "M232.55,204.556a.434.434,0,0,1-.312-.132l-1.821-1.876a15.343,15.343,0,0,1-2.73-.509l-2.837,1.251a.432.432,0,0,1-.415-.035l-4.753-3.151a.437.437,0,0,1-.194-.369l.048-3.093A14.989,14.989,0,0,1,218,194.318l-2.435-.945a.434.434,0,0,1-.268-.318l-1.133-5.589a.432.432,0,0,1,.123-.4l1.876-1.82a15.594,15.594,0,0,1,.507-2.735l-1.25-2.833a.435.435,0,0,1,.036-.416l3.151-4.753a.4.4,0,0,1,.369-.194l3.092.048a15.243,15.243,0,0,1,2.326-1.532l.945-2.437a.435.435,0,0,1,.319-.268l5.588-1.134a.442.442,0,0,1,.4.123l1.818,1.874a15.53,15.53,0,0,1,2.737.508l2.833-1.249a.439.439,0,0,1,.415.036l4.753,3.151a.434.434,0,0,1,.194.369l-.047,3.1a14.93,14.93,0,0,1,1.531,2.321l2.437.945a.433.433,0,0,1,.269.318l1.133,5.589a.436.436,0,0,1-.123.4l-1.877,1.821a15.585,15.585,0,0,1-.508,2.729l1.251,2.838a.433.433,0,0,1-.035.415l-3.151,4.753a.454.454,0,0,1-.368.194l-3.093-.047a15.28,15.28,0,0,1-2.323,1.527l-.946,2.441a.439.439,0,0,1-.319.269l-5.589,1.133A.414.414,0,0,1,232.55,204.556Zm-4.894-3.412a.422.422,0,0,1,.122.018,14.537,14.537,0,0,0,2.875.535.434.434,0,0,1,.276.131l1.767,1.821,5.124-1.039.92-2.373a.433.433,0,0,1,.2-.227,14.4,14.4,0,0,0,2.444-1.607.374.374,0,0,1,.281-.1l3.013.045,2.888-4.357-1.219-2.764a.429.429,0,0,1-.019-.3,14.767,14.767,0,0,0,.534-2.875.435.435,0,0,1,.13-.276l1.823-1.768-1.039-5.124-2.368-.918a.429.429,0,0,1-.231-.211,14.121,14.121,0,0,0-1.607-2.435.436.436,0,0,1-.1-.282l.046-3.016-4.357-2.888-2.757,1.215a.445.445,0,0,1-.3.021,14.729,14.729,0,0,0-2.885-.536.432.432,0,0,1-.275-.129l-1.766-1.821-5.123,1.04-.918,2.367a.436.436,0,0,1-.2.228,14.367,14.367,0,0,0-2.446,1.61.4.4,0,0,1-.282.1l-3.013-.047-2.888,4.358,1.217,2.76a.437.437,0,0,1-.009.37,15.1,15.1,0,0,0-.506,2.807.433.433,0,0,1-.13.276l-1.821,1.767,1.038,5.123,2.367.918a.43.43,0,0,1,.237.223,14.227,14.227,0,0,0,1.6,2.423.442.442,0,0,1,.1.284l-.047,3.013,4.358,2.89,2.763-1.22A.439.439,0,0,1,227.656,201.144Zm4.27-2.809a11.567,11.567,0,0,1-9.63-17.955h0a11.569,11.569,0,1,1,9.629,17.955Zm-8.906-17.475a10.7,10.7,0,1,0,14.835-3.012,10.623,10.623,0,0,0-14.835,3.012Z",
    transform: "translate(-199.284 -108.529)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14444",
    "data-name": "Group 14444",
    transform: "translate(209.8 41.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113198",
    "data-name": "Path 113198",
    d: "M410.942,220.575l-13.625-1.84,9.012-67.551-26.289-3.547-63.77,58.711-3.351,25.116,54.948,7.415-2.741,20.543,26.29,3.548,2.74-20.543,13.626,1.839Zm-68.949-9.305L375.642,180.6l-4.615,34.589Z",
    transform: "translate(-312.918 -147.637)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113199",
    "data-name": "Path 113199",
    d: "M394.068,262.745a.5.5,0,0,1-.079-.007.433.433,0,0,1-.348-.505l20.251-111.065a.443.443,0,0,1,.5-.35.434.434,0,0,1,.349.505L394.494,262.389A.434.434,0,0,1,394.068,262.745Z",
    transform: "translate(-323.558 -148.056)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14442",
    "data-name": "Group 14442",
    transform: "translate(66.804 4.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113200",
    "data-name": "Path 113200",
    d: "M414.615,153.258a.711.711,0,1,1-.687-.735A.712.712,0,0,1,414.615,153.258Z",
    transform: "translate(-392.941 -152.522)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113201",
    "data-name": "Path 113201",
    d: "M411.283,170.559a.711.711,0,1,1-.687-.735A.712.712,0,0,1,411.283,170.559Z",
    transform: "translate(-392.501 -154.803)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113202",
    "data-name": "Path 113202",
    d: "M407.95,187.859a.711.711,0,1,1-.687-.735A.711.711,0,0,1,407.95,187.859Z",
    transform: "translate(-392.062 -157.084)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113203",
    "data-name": "Path 113203",
    d: "M401.4,205.87a.711.711,0,1,1-.687-.735A.712.712,0,0,1,401.4,205.87Z",
    transform: "translate(-391.198 -159.458)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113204",
    "data-name": "Path 113204",
    d: "M401.285,222.461a.711.711,0,1,1-.687-.735A.711.711,0,0,1,401.285,222.461Z",
    transform: "translate(-391.183 -161.645)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113205",
    "data-name": "Path 113205",
    d: "M397.953,239.762a.711.711,0,1,1-.687-.735A.712.712,0,0,1,397.953,239.762Z",
    transform: "translate(-390.744 -163.926)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113206",
    "data-name": "Path 113206",
    d: "M394.62,257.063a.711.711,0,1,1-.686-.736A.711.711,0,0,1,394.62,257.063Z",
    transform: "translate(-390.305 -166.207)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113207",
    "data-name": "Path 113207",
    d: "M391.288,274.363a.711.711,0,1,1-.687-.735A.711.711,0,0,1,391.288,274.363Z",
    transform: "translate(-389.865 -168.487)",
    fill: "#454b57"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113208",
    "data-name": "Path 113208",
    d: "M400.728,206.252a.434.434,0,0,1-.09-.859l2.156-.463a.434.434,0,0,1,.182.849l-2.157.463A.463.463,0,0,1,400.728,206.252Z",
    transform: "translate(-324.437 -155.189)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14443",
    "data-name": "Group 14443",
    transform: "translate(79.765 42.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113209",
    "data-name": "Path 113209",
    d: "M408.585,197.241a72.322,72.322,0,0,0-2.6,8.127,71.018,71.018,0,0,0-.694,9.918",
    transform: "translate(-404.861 -196.807)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113210",
    "data-name": "Path 113210",
    d: "M405.229,215.654h0a.434.434,0,0,1-.431-.437,70.176,70.176,0,0,1,.7-10.007,71.836,71.836,0,0,1,2.616-8.192.434.434,0,0,1,.811.312,72.254,72.254,0,0,0-2.578,8.062,71.058,71.058,0,0,0-.684,9.83A.434.434,0,0,1,405.229,215.654Z",
    transform: "translate(-404.795 -196.742)",
    fill: "#454b57"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(98.845 164.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14453",
    "data-name": "Group 14453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113211",
    "data-name": "Path 113211",
    d: "M222.452,297.166c1.206-19.449-1.012-54.8,35.547-50.125,39.186,5.016,27.975,50.837,27.975,50.837Z",
    transform: "translate(-128.218 -246.619)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14446",
    "data-name": "Group 14446",
    transform: "translate(102.643 6.083)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_849",
    "data-name": "Ellipse 849",
    cx: 15.953,
    cy: 15.953,
    r: 15.953,
    transform: "translate(0.868 0.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113212",
    "data-name": "Path 113212",
    d: "M251.432,254.658C243.876,253.143,235.8,259.68,235,266.3l29.958,3.233C263.9,261.987,257.428,255.859,251.432,254.658Z",
    transform: "translate(-349.684 51.353) rotate(-53)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113213",
    "data-name": "Path 113213",
    d: "M264.15,271.359c-.214,4.171-2.487,7.444-5.077,7.311s-4.515-3.622-4.3-7.793,2.486-7.444,5.076-7.311S264.364,267.188,264.15,271.359Z",
    transform: "translate(-243.639 -256.935)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113214",
    "data-name": "Path 113214",
    d: "M248.96,287.267a16.821,16.821,0,1,1,16.821-16.821A16.84,16.84,0,0,1,248.96,287.267Zm0-31.905a15.085,15.085,0,1,0,15.085,15.085A15.1,15.1,0,0,0,248.96,255.361Z",
    transform: "translate(-232.138 -253.625)",
    fill: "#fec900"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113215",
    "data-name": "Path 113215",
    d: "M290.407,300.5a.5.5,0,0,1-.1-.011.436.436,0,0,1-.321-.524c.029-.117,2.8-11.889-.077-23.791a.434.434,0,1,1,.843-.2c2.924,12.112.108,24.079.079,24.2A.434.434,0,0,1,290.407,300.5Z",
    transform: "translate(-137.108 -250.445)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113216",
    "data-name": "Path 113216",
    d: "M287,267.6a.435.435,0,0,1-.395-.254,30.666,30.666,0,0,0-4.116-6.648.434.434,0,1,1,.672-.55,31.545,31.545,0,0,1,4.233,6.836.435.435,0,0,1-.394.615Z",
    transform: "translate(-136.119 -248.382)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113217",
    "data-name": "Path 113217",
    d: "M128.045,404.81c-.109,0-.215,0-.323,0a4.341,4.341,0,1,1,.238-8.678h.083c2.508,0,8.542-3.047,21.164-22.946a4.343,4.343,0,0,1,6.519-.946,179.659,179.659,0,0,0,32.247,22.118,4.341,4.341,0,0,1-3.928,7.741A185.147,185.147,0,0,1,153.834,382C143.254,397.905,135.4,404.81,128.045,404.81Z",
    transform: "translate(-115.173 -263.038)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113218",
    "data-name": "Path 113218",
    d: "M158.392,364.154a2.7,2.7,0,0,1-.372-.026,2.6,2.6,0,0,1-2.21-2.947c.617-4.32-.148-20.512-5.621-33.1a2.606,2.606,0,0,1,.922-3.191c11.892-8.1,37.224-9.073,38.3-9.111a2.6,2.6,0,0,1,.181,5.206c-.235.009-22.382.859-33.762,7.122,4.848,12.535,5.946,28.16,5.139,33.813A2.6,2.6,0,0,1,158.392,364.154Z",
    transform: "translate(-118.663 -255.736)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113219",
    "data-name": "Path 113219",
    d: "M161.629,367.175c-1.733-4.086-9.54-3.622-14.123-.12-2.45,1.871-5.766,7.5-6.114,9.542a3.073,3.073,0,0,0,3.493,3.679c2.993-.26,7.1-4.609,7.1-4.609-2.734,2.681.794,4.573,6.057.7C160.964,374.212,163.569,371.75,161.629,367.175Z",
    transform: "translate(-117.525 -262.128)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113220",
    "data-name": "Path 113220",
    d: "M336.64,302.024a.449.449,0,0,1-.121-.017.435.435,0,0,1-.3-.537c1.156-4.027,2.42-6.489,4.08-7.857a4.513,4.513,0,0,1,.133-2.829,5.588,5.588,0,0,1,2.051-2.609,2.219,2.219,0,0,1-.513-2.068,5.36,5.36,0,0,1,1.854-2.74,1.994,1.994,0,0,1-.492-1.309c-.022-2.589,4.782-6.533,10.212-7.274a.425.425,0,0,1,.489.372.434.434,0,0,1-.372.488c-5.154.7-9.477,4.436-9.46,6.407a1.134,1.134,0,0,0,.314.785,10.64,10.64,0,0,1,8.059-1.618c2.664.51,3.748,1.073,3.622,1.881-.236,1.522-5.911,1.837-9.715,1.384a5.332,5.332,0,0,1-1.953-.56,4.69,4.69,0,0,0-1.709,2.37,1.371,1.371,0,0,0,.43,1.42,10.064,10.064,0,0,1,6.872-.517c3.939.869,4.086,1.349,4.174,1.635a.573.573,0,0,1-.14.575c-.83.879-6.864.462-9.9-.28a4.382,4.382,0,0,1-1.044-.392,4.755,4.755,0,0,0-1.969,2.351,3.753,3.753,0,0,0-.2,2c.156-.093.315-.178.478-.256,1.8-.852,3.969-.709,6.645.435,1.775.761,2.631,1.433,2.694,2.118a.959.959,0,0,1-.495.9c-1.324.879-5.964.746-8.377-.538a3.394,3.394,0,0,1-1.335-1.291c-1.419,1.3-2.564,3.617-3.608,7.254A.433.433,0,0,1,336.64,302.024Zm4.71-8.1a2.557,2.557,0,0,0,1.059,1.057c1.959,1.043,5.813,1.281,7.259.7.3-.12.34-.219.34-.22s-.048-.489-2.172-1.4c-2.433-1.041-4.373-1.187-5.93-.449A4.751,4.751,0,0,0,341.35,293.923Zm2.895-5.7c.076.022.15.042.225.061a28.571,28.571,0,0,0,8.624.645,19.678,19.678,0,0,0-3.157-.883A9.839,9.839,0,0,0,344.244,288.221Zm1.1-4.881a5.525,5.525,0,0,0,1.248.28c4.325.512,8.145-.094,8.716-.633-.148-.134-.73-.505-2.89-.918A9.777,9.777,0,0,0,345.34,283.34Z",
    transform: "translate(-143.213 -250.331)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113221",
    "data-name": "Path 113221",
    d: "M199.139,408.005c.571-.183.38-.735-.259-.735H187.126c-22.382-2.37-38.021.807-28.166,1.556s-.695.591-7.891,3.314,53.526,3.408,59.05,0C215.212,409,191.207,410.547,199.139,408.005Z",
    transform: "translate(-118.73 -267.683)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113222",
    "data-name": "Path 113222",
    d: "M287.295,396.666l-102.273-3.39-4.244-99.165,120.773,2.7Z",
    transform: "translate(-122.724 -252.879)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113223",
    "data-name": "Path 113223",
    d: "M221.141,394.8a.434.434,0,0,1-.432-.4l-8.2-99.6a.434.434,0,0,1,.866-.071l8.2,99.6a.434.434,0,0,1-.4.468Z",
    transform: "translate(-126.907 -252.909)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14447",
    "data-name": "Group 14447",
    transform: "translate(164.571 43.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113224",
    "data-name": "Path 113224",
    d: "M303.469,397.076l27.489-4.185,8.658-92.208-21.891-3.461Z",
    transform: "translate(-303.469 -297.222)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113225",
    "data-name": "Path 113225",
    d: "M303.469,397.076l27.489-4.185,8.658-92.208-21.891-3.461Z",
    transform: "translate(-303.469 -297.222)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113226",
    "data-name": "Path 113226",
    d: "M195.35,375.684l-2.521-58.916a10.652,10.652,0,0,1,10.88-11.1l76.451,1.709a10.652,10.652,0,0,1,10.306,12.154L281.989,378.9a10.652,10.652,0,0,1-10.9,9.14l-65.452-2.169A10.653,10.653,0,0,1,195.35,375.684Z",
    transform: "translate(-124.311 -254.402)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113232",
    "data-name": "Path 113232",
    d: "M273.463,371.049a1.137,1.137,0,0,1-.842-.371l-7.432-8.134-8.019,7.327a1.14,1.14,0,0,1-1.61-.072l-7.432-8.134-8.019,7.327a1.14,1.14,0,0,1-1.61-.072l-7.432-8.134-8.019,7.327a1.138,1.138,0,0,1-1.61-.072l-7.432-8.134-8.019,7.327a1.139,1.139,0,1,1-1.537-1.683l8.86-8.1a1.139,1.139,0,0,1,1.61.072l7.432,8.134,8.018-7.327a1.139,1.139,0,0,1,1.61.072l7.432,8.134,8.019-7.327a1.14,1.14,0,0,1,1.61.072l7.432,8.135,8.019-7.327a1.137,1.137,0,0,1,1.61.072l8.2,8.975a1.139,1.139,0,0,1-.841,1.908Z",
    transform: "translate(-125.811 -271.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14450",
    "data-name": "Group 14450",
    transform: "translate(0 116.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113233",
    "data-name": "Path 113233",
    d: "M124.189,410.252l-5.433-2.591-4.847-23.585,2.631-2.9Z",
    transform: "translate(-113.909 -381.178)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14449",
    "data-name": "Group 14449",
    transform: "translate(2.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113234",
    "data-name": "Path 113234",
    d: "M124.588,410.252l7.21-4.212-6.181-19.433-8.679-5.429Z",
    transform: "translate(-116.939 -381.178)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113235",
    "data-name": "Path 113235",
    d: "M124.588,410.252l7.21-4.212-6.181-19.433-8.679-5.429Z",
    transform: "translate(-116.939 -381.178)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_113236",
    "data-name": "Path 113236",
    d: "M261.217,416.172c-.2,0-.405,0-.6-.008a4.341,4.341,0,1,1,.238-8.678c6.688.219,20.841-3.89,28.927-11.739a4.332,4.332,0,0,1,1.776-1.043c13.707-4.113,18.808,4.2,19.019,4.553l-7.473,4.419a1.176,1.176,0,0,0,.1.159c-.082-.115-2.024-2.639-8.205-1.077C284.852,412.02,269.277,416.172,261.217,416.172Z",
    transform: "translate(-132.692 -265.99)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14452",
    "data-name": "Group 14452",
    transform: "translate(110.984 125.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113237",
    "data-name": "Path 113237",
    d: "M258.8,421.675l-15.812-1-1.248-29.15,21.25.794Z",
    transform: "translate(-241.745 -391.528)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14451",
    "data-name": "Group 14451",
    transform: "translate(17.059 0.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113238",
    "data-name": "Path 113238",
    d: "M261.395,421.8l3.7-3.678,2.291-18.177-1.8-7.5Z",
    transform: "translate(-261.395 -392.443)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113239",
    "data-name": "Path 113239",
    d: "M261.395,421.8l3.7-3.678,2.291-18.177-1.8-7.5Z",
    transform: "translate(-261.395 -392.443)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_113240",
    "data-name": "Path 113240",
    d: "M362.022,401.693a2.6,2.6,0,0,1-1.574-.53c-9.024-6.859-21.223-19.036-25.9-30.783a2.639,2.639,0,0,1-.148-.533c-2.282-13.571-4.463-42.141-4.555-43.351a2.6,2.6,0,1,1,5.194-.393c.023.292,2.224,29.141,4.452,42.6,4.668,11.422,17.326,23.151,24.114,28.309a2.6,2.6,0,0,1-1.578,4.679Z",
    transform: "translate(-142.373 -256.779)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113241",
    "data-name": "Path 113241",
    d: "M379.584,413.925c-2.014,0-4.3-.913-6.785-2.713a2.605,2.605,0,0,1,3.054-4.221c2.15,1.557,3.325,1.725,3.731,1.725a2.6,2.6,0,0,1,0,5.209Z",
    transform: "translate(-147.895 -267.695)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113242",
    "data-name": "Path 113242",
    d: "M373.785,410.866c2.787-8.278,14.212-6.642,18.147-5.413a41.732,41.732,0,0,1,9.61,4.17c2.131,1.393,2.166,3.72-.675,5.049-3.5,1.639-12.3.185-12.3.185,4.551,1.992-.009,5.185-7.992,2.049C377.981,415.885,372.8,413.9,373.785,410.866Z",
    transform: "translate(-148.151 -267.424)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113243",
    "data-name": "Path 113243",
    d: "M339.431,328.909c-1.034,7.034-6.859,12.22-11.6,11.524s-4.936-6.978-3.9-14.011,2.908-12.156,7.645-11.46S340.465,321.876,339.431,328.909Z",
    transform: "translate(-141.529 -255.62)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_850",
    "data-name": "Ellipse 850",
    cx: 0.711,
    cy: 0.711,
    r: 0.711,
    transform: "translate(82.604 43.788)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113244",
    "data-name": "Path 113244",
    d: "M217.992,303.67a.711.711,0,1,1-.711-.712A.711.711,0,0,1,217.992,303.67Z",
    transform: "translate(-127.442 -254.046)",
    fill: "#454b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113245",
    "data-name": "Path 113245",
    d: "M218.909,400.575a.711.711,0,1,1-.711-.712A.711.711,0,0,1,218.909,400.575Z",
    transform: "translate(-127.563 -266.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113246",
    "data-name": "Path 113246",
    d: "M226.423,406.478a.711.711,0,1,1-.712-.712A.712.712,0,0,1,226.423,406.478Z",
    transform: "translate(-128.554 -267.598)",
    fill: "#454b57"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.3cf39e4ae454c936319630879e6bf0d3.svg";
export { ForwardRef as ReactComponent };